import styled from 'styled-components';

import Button from '@mlb/react-patterns/components/Button/button.tsx';
import COLORS from '@mlb/react-patterns/style/universal.color';
import FONTS from '@mlb/react-patterns/style/fonts.ts';
import { media } from '@mlb/react-patterns/style/helpers/media.ts';

const TagsList = styled.ul`
    border-top: 1px solid ${COLORS.mlbGrey6};
    border-bottom: 1px solid ${COLORS.mlbGrey6};
    width: 100%;
    padding: 4px 6px 4px 14px;

    ${media.lgmin`
        padding: 8px 6px 8px 32px;
    `}
`;

const TagGroup = styled.li`
    display: inline;
    margin: 6px 20px 6px 0;
    align-items: center;
`;

const TagGroupLabel = styled.span`
    margin-right: 10px;
    font-size: 11px;
    color: ${COLORS.mlbGrey2};
    font-family: ${FONTS.primaryFont};
    line-height: 31px;
`;

const Tag = styled(Button)`
    &&&{
        font-size: 11px;
        border-radius: 5px;
        height: 24px;
        padding: 5px 7px;
        margin: 3px 5px 4px 0;

        svg {
            vertical-align: initial;
            width: 8px;
            height: 8px;
        }

        :last-of-type {
            margin-right: 0;
        }
    }
`;

export {
    Tag,
    TagGroup,
    TagsList,
    TagGroupLabel
};
